export function initCustomSelects(selector = '[data-role="custom-select"]') {
    document.querySelectorAll(selector).forEach((selectElement) => {
        const optionsList   = selectElement.nextElementSibling;
        const svgChevron    = selectElement.previousElementSibling;

        // toggle open/close on click
        selectElement.addEventListener('click', () => {
            optionsList.style.display = 'block';
            svgChevron.style.transform = 'rotate(180deg)';
        });

        // set value when an option is clicked
        optionsList.addEventListener('click', (event) => {
            if (event.target.classList.contains('option-item')) {
                selectElement.value = event.target.textContent;
                optionsList.style.display = 'none';
                svgChevron.style.transform = 'rotate(0deg)';
            }
        });

        // close if clicking outside
        document.addEventListener('click', (event) => {
            if (
                !selectElement.contains(event.target) &&
                !optionsList.contains(event.target)
            ) {
                optionsList.style.display = 'none';
                svgChevron.style.transform = 'rotate(0deg)';
            }
        });
    });
}
